import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import styles from "./styles.module.scss";

interface StoreCarouselNavProps {
  label: string;
  onPrev: () => void;
  onNext: () => void;
}

export function StoreCarouselNav({ label, onPrev, onNext }: StoreCarouselNavProps) {
  return (
    <div className={styles.nav}>
      <button className={styles.button} type="button" onClick={onPrev} aria-label={`${label}: anterior`}>
        <IconChevronLeft size={16} aria-hidden="true" />
      </button>
      <button className={styles.button} type="button" onClick={onNext} aria-label={`${label}: próximo`}>
        <IconChevronRight size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
